// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProposalVoteInfoPills_wrapper__cn13c","voteStatusWrapper":"ProposalVoteInfoPills_voteStatusWrapper__3eD-a"};